<template>
  <div class="productionFile">
    <treeLayout
      :treeData="treeData"
      v-model="currentNode"
      @menu-click="menuClick"
    >
      <component
        :is="currentStep.stepSfzj === '01' ? currentStep.stepZjmc : 'infoTable'"
        ref="infoTable"
        :step-id="currentNode"
        :step="currentStep"
        :breedBatch="breedBatch"
        :disabled="disabled"
      ></component>
    </treeLayout>
  </div>
</template>
<script>
export default {
  name: "productionFile",
  components: {
    infoTable: () => import("./components/infoTable"),
  },
  props: {
    compId: {
      require: true,
      type: String,
      default: "",
    },
    batchNum: {
      require: true,
      type: String,
      default: "",
    },
    breedBatch: {
      type: Object,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentNode: "",
      currentStep: {},
      treeData: [],
    };
  },
  computed: {},
  watch: {
    currentNode: function (val) {},
  },
  created() {
    this.getData();
  },
  mounted() {},
  methods: {
    /**
     * 设置高亮菜单
     * @param node
     */
    setCurrentNode(node) {
      this.currentNode = node.id;
      this.currentStep = node;
    },
    /**
     * 菜单点击回调
     * @param node
     */
    menuClick(node) {
      this.currentStep = node;
    },
    getData() {
      this.$api
        .formPost("/api/major/breed/comp/step/doGetListTree", {
          compId: this.compId,
          batchNum: this.batchNum,
        })
        .then((res) => {
          this.currentNode = res.retBody[0].children[0].compStepId;
          this.currentStep = res.retBody[0].children[0];
          console.log("currentStep",this.currentStep)
          this.treeData = this.setData(res.retBody);
        });
    },
    /**
     * 格式化参数
     * @param list
     * @returns {*}
     */
    setData(list) {
      for (const listElement of list) {
        listElement.id = listElement.compStepId;
        listElement.label = listElement.compStepMc;
        if (listElement.children && listElement.children.length > 0) {
          this.setData(listElement.children);
        }
      }
      return list;
    },
  },
};
</script>
<style lang="scss" scoped>
.productionFile {
  height: 100%;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/productionFile/index.vue